
















import Vue from 'vue';

export default Vue.extend({

  name: 'TeamCardMenu',

  components: {
  },

  props: {
    team: {
      type: Object,
      default:  () => {},
    },
    menu: {
      type: Array,
      default:  () => [],
    },
  },

  data() {
    return {
    };
  },

  created() {
  },

  mounted() {
  },

  watch: {
  },

  computed: {
    teamName(): string {
      if (Object.keys(this.team).length){
        const name: string  = ( this.team.name ? String(this.team.name) : '' );
        const res: string = ( name.length > 8 ? String(name.substring(0, 8)) + '...' : String(name) );
        return res;
      } else {
      return '';
      }
    },

    isOwner(): boolean {
      let userId: string = this.$store.getters.getUserId;
      let isOwner: boolean = (this.team.ownerUserId == userId);
      return isOwner;
    },

  },

  methods: {
  },


});

